import {CSSProperties, ReactNode} from "react";
import {LoadingIndicator} from "@web-libs/ui/ui-components/loading/loading-indicator";
import {ErrorCard} from "@web-libs/ui/ui-components/card/error-card";

export type OnValueLoadFunction<T> = (value: T) => ReactNode;

type AbstractLoaderProps = {
    loading?: boolean
    error?: string
    style?: CSSProperties
    stretchError?: boolean
    fitParent?: boolean
}

export type LoaderProps<T> = AbstractLoaderProps & {
    value: T | undefined | null
    children: OnValueLoadFunction<T>
}

export type SimpleLoaderProps = AbstractLoaderProps & {
    children: ReactNode,
}

function handleLoadingAndErrorStates(loading: boolean, error?: string, style?: CSSProperties, stretchError?: boolean, fitParent?: boolean) {
    const _centerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...style
    }

    if(fitParent) {
        _centerStyle.height = "100%"
        _centerStyle.width = "100%"
    }

    const errorStyle = {
        ..._centerStyle,
    }

    if(stretchError) {
        errorStyle.alignItems = "stretch"
        errorStyle.flexDirection = "column"
    }

    if (loading) {
        return <div style={_centerStyle}><LoadingIndicator color={"primary"}></LoadingIndicator></div>
    }
    if (error) {
        return <div style={errorStyle}>
            <ErrorCard text={error}></ErrorCard></div>
    }

    return null;
}

export function Loader<T>({value, loading, error, children, style, stretchError}: LoaderProps<T>) {
    const loadingOrErrorState = handleLoadingAndErrorStates(loading ?? false, error, style, stretchError);
    if (loadingOrErrorState) {
        return loadingOrErrorState;
    }
    if (value) {
        return <>{children(value)}</>
    }
    return <></>
}

export function SimpleLoader({loading, error, children, style, stretchError, fitParent}: SimpleLoaderProps) {
    const loadingOrErrorState = handleLoadingAndErrorStates(loading ?? false, error, style, stretchError, fitParent);
    if (loadingOrErrorState) {
        return loadingOrErrorState;
    }
    return <>{children}</>
}
